import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { login as loginApi, fetchCurrentUser } from "../api/api";
import { useAuth } from "../context/AuthContext";
import { getRoleHomePage } from "../utils/roleHome";
import CountryCodeSelect from "../components/CountryCodeSelect";
import { DEFAULT_COUNTRY_CODE, combineMobile } from "../utils/countryCodes";

function Login() {

  const navigate = useNavigate();
  const { login } = useAuth();

  const [countryCode, setCountryCode] = useState(DEFAULT_COUNTRY_CODE);
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const tokens = await loginApi(combineMobile(countryCode, mobile), password);
      localStorage.setItem("token", tokens.access_token);
      const userData = await fetchCurrentUser();
      login(tokens, userData);

      if (userData?.must_change_password) {
        // Carry the password they just typed forward so Change Password
        // can pre-fill "Current password" instead of making them retype
        // what they entered seconds ago.
        navigate("/change-password", { state: { tempPassword: password } });
      } else {
        navigate(getRoleHomePage(userData?.role?.name));
      }
    } catch (err) {
      const status = err.response?.status;
      if (status === 401) {
        setError("Invalid mobile number or password.");
      } else if (status === 403) {
        setError("This account has been disabled.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (

    <div className="login-page">

      {/* LOGIN BOX */}

      <form className="login-box" onSubmit={handleLogin}>

        <h1>🌿 Farm Login</h1>

        <p className="login-subtitle">
          Welcome Back To Jain Farms
        </p>

        {error && (
          <p className="login-error" style={{ color: "red" }}>
            {error}
          </p>
        )}

        <div className="phone-row">
          <CountryCodeSelect value={countryCode} onChange={setCountryCode} />
          <input
            type="tel"
            placeholder="Mobile Number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
        </div>

        <div className="password-field">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            className="password-toggle-btn"
            onClick={() => setShowPassword((prev) => !prev)}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>


        <button
          type="submit"
          className="login-btn"
          disabled={submitting}
        >

          {submitting ? "Logging in..." : "Login"}

        </button>

        <button
          type="button"
          className="forgot-password-link"
          onClick={() => navigate("/forgot-password")}
        >
          Forgot Password?
        </button>

          <button
  type="button"
  className="register-btn"
  onClick={() => navigate("/customer-registration")}
>
  Register
</button>
      </form>

    </div>

  );
}

export default Login;
